<template>
  <section>
    <mdb-modal
      centered
      elegant
      scrollable
      :show="mostrarModal"
      @close="$emit('cerrar')"
    >
      <mdb-modal-header>
        <mdb-modal-title>¿Quieres editar este pedido?</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <div class="contenido-mensaje">
         <font-awesome-icon icon="exclamation-circle" size="5x" class="icono texto-primario" />
          <p>
            Ten en cuenta que, al realizar cambios, el pedido volverá al inicio del proceso para ser revisado nuevamente. Esto asegura que toda la información nueva sea correcta.
          </p>
        </div>
        <div class="actions">
          <mdbBtn
          color="primario"
            icon="check"
            class="rounded-lg"
            title="Continuar"
            @click="$emit('cerrar')">
            Aceptar
          </mdbBtn>
        </div>
      </mdb-modal-body>
    </mdb-modal>
  </section>
</template>

<script>
import {mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbBtn} from 'mdbvue';

export default {
  name: 'MensajePedidoEditar',
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbBtn,
  },
  data() {
    return {
    };
  },
  props: {
    mostrarModal: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang='scss' scoped>
.contenido-mensaje {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.actions{
  display: flex;
  justify-content: center;
}
</style>
